import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SnackbarContent, SnackbarState } from "./snackBarTypes";

const initialState: SnackbarState = {
  open: false,
  content: { message: "", severity: "success", autoHide: null },
};

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    showSnackbar: (state, action: PayloadAction<SnackbarContent>) => {
      state.open = true;
      state.content = action.payload;
    },
    hideSnackbar: (state) => {
      state.open = false;
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
